export default __webpack_public_path__ + "static/kibo-4c2a6c580494ec458fddc246a615363a.jpg";